import { DialogSize } from '../../../../../../../react-commons/components/data-display/dialog/ResizableDialog';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultImageAttachmentResource,
    ImageAttachmentMutationResourceSchema,
    type ImageAttachmentResource,
    useImageAttachmentActions,
} from '../../../../../resource/resources/artifacts/attachment/imageAttachmentResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { creationDialogOnSuccess } from '../../../../util/utilFunctions';
import { ImageAttachmentContent } from './ImageAttachmentContent';

export const ImageAttachmentCreationDialog = ({
    onClose,
    parentId,
    autoGeneratedProps,
    onCreated,
}: {
    onClose: () => void;
    parentId: string;
    autoGeneratedProps?: ImageAttachmentResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const imageAttachmentActions = useImageAttachmentActions();
    const addImageAttachment = imageAttachmentActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: ImageAttachmentMutationResourceSchema,
        defaultValues: {
            ...defaultImageAttachmentResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addImageAttachment.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Image Attachment'}
            resourceType={ResourceType.IMAGE_ATTACHMENT}
            dialogSize={DialogSize.MEDIUM_LARGE}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <ImageAttachmentContent form={form} formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};
